import { FormHelperText } from "@mui/material";
import { Icon } from "@iconify/react";
import React from "react";
import { colCenter } from "../style/style";
export const ErrorMessage = ({ error }) => {
    return (error && (React.createElement(FormHelperText, { error: true, sx: Object.assign(Object.assign({}, colCenter), { gap: 0.5, ml: 0 }) },
        React.createElement(Icon, { icon: "eva:alert-triangle-fill", width: "16", height: "16" }),
        error)));
};
